import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './cyberpunk.css';
import { playKeyClick } from './audioEngine.js';

// 2026-08-27 owner report ("admin from the sidenav shows a black page"): every page in
// App.jsx is a React.lazy chunk with a content-hashed filename. A browser (especially
// the desktop shell, which stays open for days) still running an OLD index.html asks for
// chunk hashes that stopped existing at the last deploy -> the dynamic import rejects ->
// the screen renders black. Vite reports exactly this as 'vite:preloadError'; one
// automatic reload picks up the fresh index and fixes it. sessionStorage guard so a
// genuinely-broken deploy can't reload-loop forever.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'aetheris_chunk_reload';
  if (!sessionStorage.getItem(KEY)) {
    event.preventDefault();
    sessionStorage.setItem(KEY, '1');
    window.location.reload();
  }
});
// Guard clears only after the reloaded page has demonstrably worked for a while --
// clearing on 'load' would re-arm instantly and let a genuinely broken deploy loop.
setTimeout(() => sessionStorage.removeItem('aetheris_chunk_reload'), 15000);

const INTERACTIVE = ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON', 'A'];

// Key click on keydown inside any input/textarea/select
document.addEventListener('keydown', (e) => {
  if (INTERACTIVE.includes(e.target.tagName)) {
    playKeyClick();
  }
});

// Click feedback on buttons and links
document.addEventListener('click', (e) => {
  const tag = e.target.tagName;
  const role = e.target.getAttribute('role');
  if (tag === 'BUTTON' || tag === 'A' || role === 'button') {
    playKeyClick();
  }
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
);

// Production-only: the dev server serves public/ too, and registering there would mean
// every dev session fights its own service worker cache instead of seeing live edits.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Non-fatal -- the app works identically with no SW, just without the repeat-visit
      // asset caching. Never let a registration failure surface to the user.
    });
  });
}
